import { useRouter } from 'hooks/useRouter'

export const getCleanRoute = (pathname: string, params: object) =>
  pathname
    ?.split('/')
    .map((segment) => {
      if (Object.values(params)?.includes(segment)) {
        return '[id]'
      }
      return segment
    })
    .join('/')

export const useRouteMatch = (allowedUrls: string[]) => {
  const router = useRouter()

  const cleanRoute = getCleanRoute(router?.location?.pathname, router?.params)

  return allowedUrls.some((route) => route === cleanRoute)
}
